import { RolesEnum } from '@/core/enums';
import { companiesSelector, userSelector } from '@/core/store/user/userSlice';
import { APIEventsEnum, useAppSelector, useSendEvent } from '@/hooks';
import { createContext, useState, ReactNode, useEffect } from 'react';

export const PaymentOverdueModalContext = createContext<{
  isModalOpened: boolean;
  closeModal: () => void;
  openModal: (v?: string) => void;
}>({
  isModalOpened: false,
  closeModal: () => {},
  openModal: () => {},
});

export function PaymentOverdueModalWrapper({
  children,
}: {
  children: ReactNode;
}) {
  const { sendEvent } = useSendEvent();
  const [isModalOpened, setIsModalOpened] = useState(false);
  const companies = useAppSelector(companiesSelector);
  const companyWithPaymentOverdue = companies.find(
    (company) => company.PaymentOverdue
  );
  const user = useAppSelector(userSelector);

  const closeModal = () => {
    setIsModalOpened(false);
  };

  const openModal = () => {
    setIsModalOpened(true);
  };

  useEffect(() => {
    if (user && user.Role === RolesEnum.SELLER && companyWithPaymentOverdue) {
      openModal();
      sendEvent(APIEventsEnum.payment_overdue_client_login, {
        company_with_debt: companyWithPaymentOverdue.company_id,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyWithPaymentOverdue]);

  return (
    <PaymentOverdueModalContext.Provider
      value={{
        isModalOpened,
        closeModal,
        openModal,
      }}
    >
      {children}
    </PaymentOverdueModalContext.Provider>
  );
}
